<template>
    <div>
        <slot :loading="loading || !ready" />

        <template v-if="ready">
            <div class="mb-3 mb-lg-5">
                <Filters
                    :value="value"
                    :criterias="criterias"
                    @input="handleValueChanged"
                    :key="hydratingKey"
                />
            </div>

            <template v-if="availabilities.length > 0">
                <div style="max-width: 700px">
                    <div class="list-group mx-n3">
                        <template v-for="availability in availabilities">
                            <AvailabilityItem :availability="availability" :key="availability.id" />
                        </template>
                    </div>
                </div>
            </template>
            <template v-else>
                <em class="text-muted">
                    Aucun plateaux n'est disponible à cette date
                </em>
            </template>

            <template v-if="results.meta.last_page > 1">
                <div class="mt-4">
                    <b-pagination
                        :value="currentPage"
                        :total-rows="results.meta.total"
                        :per-page="results.meta.per_page"
                        hide-goto-end-buttons
                        first-number
                        last-number
                        prev-class="mr-2"
                        next-class="ml-2"
                        @change="handlePageChanged"
                    >
                        <template v-slot:prev-text>
                            <svg width=".75em" height=".75em">
                                <use xlink:href="#sprite-arrow-left" />
                            </svg>
                        </template>
                        <template v-slot:next-text>
                            <svg width=".75em" height=".75em">
                                <use xlink:href="#sprite-arrow-right" />
                            </svg>
                        </template>
                    </b-pagination>
                </div>
            </template>
        </template>
    </div>
</template>

<script>
    import { BPagination } from 'bootstrap-vue';
    import { search, setup, onMounted, routesEquals } from "../util/search";
    import { parseQuery, serializeQuery } from "./util/query";
    import { getRoomAvailabilities } from "./api";
    import router from './router';
    import Filters from "./Filters";
    import AvailabilityItem from "./AvailabilityItem";

    export default {
        router,
        components: {
            AvailabilityItem,
            Filters,
            BPagination,
        },
        props: {
            criterias: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                ready: false,
                loading: false,

                value: null,
                results: null,
                error: null,

                hydratingKey: 0,
            }
        },
        computed: {
            availabilities() {
                return this.results?.data ?? [];
            },
            currentPage() {
                return Number(this.$route.query.page ?? 1);
            },
        },
        methods: {
            handleValueChanged(value) {
                this.$router.push({
                    query: {
                        ...serializeQuery(value),
                        page: 1,
                    }
                });
            },
            handlePageChanged(page) {
                if(page === this.currentPage) {
                    return;
                }
                this.$router.push({
                    query: serializeQuery({
                        ...this.value,
                        page,
                    }),
                });
                window.scrollTo(0, this.$el.offsetTop - 180);
            },
            init(route, oldRoute) {
                if(routesEquals(route, oldRoute)) {
                    return;
                }
                const query = parseQuery(this.$route.query);
                const value = {
                    ...query,
                };
                return search(this, ({ cancelToken }) =>
                    getRoomAvailabilities(value, { cancelToken })
                        .then(data => {
                            const { results, search } = data;
                            this.results = results;
                            this.value = search;
                        })
                );
            },
        },
        async created() {
            await setup(this, () => ({
                route: {
                    name: 'home',
                    query: serializeQuery(this.value),
                },
            }));

            if(this.currentPage > 1 && !this.results.data.length) {
                this.$router.replace({
                    query: {
                        ...this.$route.query,
                        page: 1,
                    },
                });
            }
        },
        mounted() {
            onMounted(this);
        },
    }
</script>
